import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { costs } from '../data/problems';
export function ProblemSection() {
  return <section className="border-t border-primary/30 bg-background py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-157" data-mp="30hzhn1ayjuld">
      <div className="mx-auto max-w-4xl px-4" data-id="element-158" data-mp="2vp6c4b7o0i88">
        <div className="text-center" data-id="element-159" data-mp="39hcsnyeqcr87">
          <SectionHeading id="problem-title" data-id="element-160" data-mp="39gb4cs8pe88j">Does This Sound <span className="text-highlight" data-id="element-161" data-mp="35gki91u4ggac">Familiar?</span></SectionHeading>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-muted" data-id="element-162" data-mp="35in73ijjg3dh">
            You teach biology or science, and genetics is one of the units your students find hardest. Between the DNA
            molecule, Mendel&apos;s laws, gene expression, mutations, biotechnology and evolution, it&apos;s hard to find
            clear, connected materials that take your class from one idea to the next.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 rounded-2xl border border-primary/70 bg-surface p-6 shadow-lg shadow-foreground/10 sm:p-8" data-id="element-163" data-mp="jdwkyyd05oww">
          <p className="mb-5 inline-flex items-center gap-2 text-xl font-extrabold uppercase text-foreground" data-id="element-164" data-mp="x6ctufsl4h5q">
            <AlertTriangleIcon className="h-5 w-5 text-accent" aria-hidden="true" data-id="element-165" data-mp="172pj91h3k8uo" />
            The real cost:
          </p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-166" data-mp="1c1j093vlehzl">
            {costs.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-muted" data-id="element-167" data-mp="1g3dyfzi88f95">
                <span className="glow-line mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full bg-highlight" aria-hidden="true" data-id="element-168" data-mp="1g11j7u3usizs" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <div className="mt-10 text-center" data-id="element-169" data-mp="3hwkby9edbhfu">
          <p className="mx-auto max-w-2xl text-lg font-bold text-foreground" data-id="element-170" data-mp="ozh6gjh07gpu">
            You don&apos;t need more scattered resources.
          </p>
          <p className="mt-3 text-2xl font-extrabold uppercase tracking-tight text-accent sm:text-3xl" data-id="element-171" data-mp="k3ab1km8hnm5">You need one organized system.</p>
        </div>
      </div>
    </section>;
}